import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevrons-left",
  "use": "chevrons-left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"chevrons-left\">\n<path d=\"M11,18c-0.3,0-0.5-0.1-0.7-0.3l-5-5c-0.4-0.4-0.4-1,0-1.4l5-5c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L7.4,12l4.3,4.3\n\tc0.4,0.4,0.4,1,0,1.4C11.5,17.9,11.3,18,11,18z\" />\n<path d=\"M18,18c-0.3,0-0.5-0.1-0.7-0.3l-5-5c-0.4-0.4-0.4-1,0-1.4l5-5c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L14.4,12l4.3,4.3\n\tc0.4,0.4,0.4,1,0,1.4C18.5,17.9,18.3,18,18,18z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol